"use strict";
var modules = {};

		function pathConcat() {
			var ap = [].slice.call(arguments).map(function(v) {
				return v.split('/').filter(function(v) { return !!v; });
			}).reduce(function(prev, next) {
				return prev.concat(next);
			}, []);
			var pp = [];
			ap.forEach(function(key) {
				if (key == '.') return;
				if (key == '..') { pp.pop(); return; }
				pp.push(key);
			});
			return pp.join('/');
		}
		
		function append(searchPath, name) {
			if (searchPath.indexOf(name) != -1) searchPath.splice(searchPath.indexOf(name), 1);
			searchPath.push(name);
			return searchPath;
		}
		
		var DummyModule = {};
		Object.defineProperty(DummyModule, '__esModule', { value: true });
		if (Object.freeze) Object.freeze(DummyModule);
		
		function requireInner(searchPath, moduleEntry, index, name) {
			function getEntry(module, moduleEntry, index, path) {
				if (module.module) {
					return module.module.exports;
				}
				module.module = { exports: {} };
				module.construct.call(
					null,
					global,
					module.module,
					module.module.exports,
					global.console,
					requireInner.bind(null, path, moduleEntry, index - 1)
				);
				return module.module.exports;
			}
			
			if (name == '$previous' && moduleEntry) {
				if (index < 0) {
					return DummyModule;
				}
				
				var module = moduleEntry[index];
				return getEntry(module, moduleEntry, index, searchPath);
			}
			
			for (var i = searchPath.length - 1; i >= 0; i--) {
				var pc = pathConcat(searchPath[i], name);
				if (modules[pc]) {
					var q = modules[pc];
					var module = q[q.length - 1], index = q.length - 1;
					return getEntry(module, modules[pc], index, append(searchPath.slice(), pathConcat(pc, '..')));
				}
			}
			
			throw new Error("Can't find module " + name + "; looked in " + JSON.stringify(searchPath.reverse()));
		}
		
		modules['require'] = [
			{
				construct: function() {},
				module: {
					exports: requireInner.bind(null, [""], null, 0)
				}
			}
		];

		modules['exports'] = [
			{
				construct: function() {},
				module: {
					exports: {}
				}
			}
		];

		modules['jQuery'] = modules['jquery'] = [
			{
				construct: function(global, module, exports, console, require) {
					Object.defineProperty(exports, '__esModule', { value: true });
					exports.default = global.$;
				}
			}
		];
		
		modules['platform/ClientAPI'] = [
			{
				construct: function(global, module, exports, console, require) {
					Object.defineProperty(exports, '__esModule', { value: true });
					exports.default = ClientAPI;
				}
			}
		];
		
		modules['defineModule'] = [
			{
				construct: function(global, module, exports, console, require) {
					function defineModule(moduleId, exec) {
						if (!modules[moduleId]) modules[moduleId] = [];
						modules[moduleId].push({
							construct: function(global, module, exports, console, require) {
								exec.call(null, global, module, exports, console, require);
							}
						});
					}
					
					exports = module.exports = {
						__esModule: true,
						default: defineModule,
						defineModule: defineModule
					};
				}
			}
		];

		global.require = modules.require[0].module.exports;
		global.defineModule = function(moduleId, exec) {
			console.trace('deprecated global.defineModule() call');
			if (!modules[moduleId]) {
				modules[moduleId] = [];
			}
			modules[moduleId].push({
				construct: function(global, module, exports, console, require) {
					exec.call(null, global, module, exports, require);
				}
			});
		}
		var defineModule = global.require('defineModule').default;
	